import React, { useContext } from 'react';
import classNames from 'classnames';
import MembersTable from '../../MembersTable';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { Button } from 'ncoded-component-library';
import SettingsIcon from 'icons/Settings.icon';
import ManageBuyerGroup from '../../ManageBuyerGroup';
import { SideDrawerRef } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { DataRoomBuySideGroup } from 'router/subrouters/DataRoom/models/DataRoomMember';

import './BuySideInstance.styles.scss';

type BuySideInstanceProps = {
  className?: string;
  group: DataRoomBuySideGroup;
  showEditGroupButton: boolean;
};

const BuySideInstance: React.FC<BuySideInstanceProps> = ({
  className,
  group,
  showEditGroupButton = true,
}) => {
  const classes = classNames('buy-side-instance', 'white-panel', className);

  const { dataRoomMembers, name } = group;

  const [buyGroup, buyGroupRef] = useCallbackRef<SideDrawerRef>(null);

  const { doesntHaveAccess } = useContext(DataRoomContext);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div className="instance-trigger">
        <div className="instance-trigger__title">
          <p className="name">{name}</p>
          <p className="num-of-members">
            {t('numOfMembers', { count: group.dataRoomMemberIds.length })}
          </p>

          {!doesntHaveAccess && showEditGroupButton && (
            <Button
              variant="icon"
              icon={SettingsIcon}
              onClick={() => buyGroup?.setOpen(true)}
            />
          )}
        </div>
      </div>

      <MembersTable isBuySide members={dataRoomMembers} />

      <ManageBuyerGroup ref={buyGroupRef} group={group} />
    </div>
  );
};

export default BuySideInstance;
